import { useEffect, useRef } from "react";
import Icon from "./Icon";

export default function QrControls({ scanning, closing, qrContainerRef, qrFileInputRef, handleScanClick, handleScanFile, disabled }) {
  const closeRef = useRef(null);
  const scanButtonRef = useRef(null);
  const scanClickRef = useRef(handleScanClick);
  scanClickRef.current = handleScanClick;
  useEffect(() => {
    if (!scanning) return undefined;
    const scanButton = scanButtonRef.current;
    closeRef.current?.focus();
    const escape = event => { if (event.key === "Escape") scanClickRef.current(); };
    window.addEventListener("keydown", escape);
    return () => { window.removeEventListener("keydown", escape); scanButton?.focus(); };
  }, [scanning]);
  return <>
    <div className="voice-qr-row"><button type="button" className="voice-button quiet" onClick={handleScanClick} ref={scanButtonRef} disabled={disabled}><Icon name="scan" />{scanning ? "Stop camera" : "Scan QR"}</button><button type="button" className="voice-button quiet" onClick={() => qrFileInputRef.current?.click()} disabled={disabled || scanning}><Icon name="image" />QR image</button></div>
    <input type="file" accept="image/*" aria-label="Upload QR image" onChange={(event) => event.target.files?.length && handleScanFile(event.target.files[0])} ref={qrFileInputRef} className="voice-file-input" disabled={disabled || scanning} />
    <div className="voice-scanner" hidden={!scanning && !closing}><div className="voice-panel-head"><h3>{closing ? "Closing camera…" : "Scan vehicle QR"}</h3><button type="button" className="voice-icon-button" ref={closeRef} onClick={handleScanClick} disabled={closing} aria-label="Close scanner"><Icon name="close" /></button></div><p>Position the QR code inside the frame.</p><div id="qr-reader" ref={qrContainerRef} /></div>
    <div id="qr-reader-hidden" className="voice-file-input" aria-hidden="true" />
  </>;
}
